<template>
    <section class="reset-password">
        <h1 class="text-center">Reset Password</h1>
        <form @submit.prevent="resetPassword()">
            <div class="form-group">
                <input type="password" class="form-control" v-model="newPassword" placeholder="New Password">
            </div>
            <div class="form-group">
                <input type="password" class="form-control" v-model="confirmNewPassword" placeholder="Confirm New Password">
            </div>
            <div class="form-group">
                <input type="submit" value="Reset">
            </div>
        </form>
    </section>
</template>
<script>
import auth from '../services/auth';

import toastr from 'toastr';
export default {
    data() {
        return {
            token: null,
            id: null,
            newPassword: null,
            confirmNewPassword: null
        }
    },
    mounted() {
        this.token = this.$route.query.token;
        this.id = this.$route.query.id;
    },
    methods: {
        resetPassword() {

            function scorePassword(pass) {
                var validated = true;
                if (pass.length < 8)
                    validated = false;
                if (!/\d/.test(pass))
                    validated = false;
                if (!/[a-z]/.test(pass))
                    validated = false;
                if (!/[A-Z]/.test(pass))
                    validated = false;

                return validated;
            }

            var self = this;
            if (!this.token) {
                toastr.error('Please click the link in your email.');
                return;
            }
            if (!this.newPassword || !this.confirmNewPassword) {
                toastr.error('Please set and confirm your new password');
                return;
            }
            if (this.newPassword !== this.confirmNewPassword) {
                toastr.error('Password and confirmation do not match');
                return;
            }

            var validPassword = scorePassword(this.newPassword);

            if (validPassword === false) {
                toastr.error("Please use a strong password, at least 8 characters, with a mixture of uppper- and lower-case letters and numbers, and no special characters");
                return false;
            }

            var data = {
                newPassword: this.newPassword,
                confirmPassword: this.confirmNewPassword,
                token: this.token,
                id: this.id
            }
            auth.resetPassword(this, data).then(function(response) {
                if (response.data.success === true) {
                    toastr.success('Password Changed');
                    window.setTimeout(function() {
                        self.$router.push('/');
                    }, 100);
                } else {
                    toastr.error(response.data.message);
                }
            })
        }
    }
}

</script>
<style lang="scss" scoped>
h1 {
    font-weight: 300;
    text-transform: uppercase;
    letter-spacing: 4px;
    margin-top: 10vh;

}

form {
    width: 380px;
    max-width: 100%;
    margin-top: 2rem;
    margin: 0 auto;
}

input[type="submit"] {
    background: transparent;
    color: #fff;
    border: 1px solid #fff;
    padding: .5rem 1rem;
}

</style>



// WEBPACK FOOTER //
// ResetPassword.vue?71d26285